export const colorButton = '#ceeae7'

export const colorTitleButton = '#3b2910'

export const backgroundMenu = '#454444'

export const textMenu = '#bfbcbc'

export const backgroundColor = '#201c17'

export const Globalurl = ' https://api.z-api.io/';

export const secretToken = 'Fc74d09cd06a74c7786d6656cc984ac7fS';
